export default __webpack_public_path__ + "static/media/B0006.a149d9be.png";